import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import axios, { AxiosInstance } from "axios";
import Select2 from "vue3-select2-component";



// const axiosInstance = axios.create({
//   baseURL: "https://hshbackendv2-api-dev.azurewebsites.net",
// });

// const axiosInstance = axios.create({
//   baseURL: "https://hshbackendv2-api-pre-prod.azurewebsites.net",
// });


// const axiosInstance = axios.create({
//   baseURL: "https://hshbackendv2-api.azurewebsites.net",
// });


const createApiClient = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: { 'Content-Type': 'application/json' },
  });

  // Add a single interceptor with fallback
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token') || store?.getters?.getToken;
      if (token) {
        config.headers['Authorization'] = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  return instance;
};



// export const apiV1 = createApiClient('https://hshbackendv2-api-dev.azurewebsites.net'); // dev

export const apiV1 = createApiClient('https://api-v2.my-farm.in'); // prod
// export const apiV1 = createApiClient('https://api-v2-dev.my-farm.in'); // dev
// export const apiV1 = createApiClient('http://localhost:8085'); // local
// export const apiV2 = createApiClient('http://localhost:3001/api/v1');

// Register globally
const app = createApp(App);

// Option 1: Add both as properties
app.config.globalProperties.$apiV1 = apiV1;
// app.config.globalProperties.$apiV2 = apiV2;
app.use(store);
app.use(router);

app.use(VueSweetalert2);
app.component("Select2", Select2);



app.mount("#app");
